<template>
    <moe-page class="page_gray">
        <moe-top></moe-top>
        <div class="bg_gray">
            <div class="integral_detail">
                <div class="detail_text">积分明细</div>
                <div class="detail_box">
                    <div class="detail_top flex Flexalign FlexBetween">
                        <div class="top_one">详细说明</div>
                        <div class="top_one">收入/支出时间</div>
                        <div class="top_one">收入/支出积分</div>
                        <div class="top_one">余额</div>
                    </div>
                    <div class="detail_content">
                        <div class="detail_one flex Flexalign FlexBetween" v-for="(item, index) in detailList"
                            :key="index" :class="{ 'detail_one_active': index % 2 == 1 }">
                            <div class="top_one">{{ item.explain }}</div>
                            <div class="top_one">{{ item.time }}</div>
                            <div class="top_one" :class="[item.type == 1 ? 'red_color' : 'green_color']">{{ (item.type
                                ==
                                1 ?
                                '+' : '-') + item.integralNum }}</div>
                            <div class="top_one">{{ item.balance }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </moe-page>
</template>

<script>
export default {
    name: 'GjkcH5Detail',

    data() {
        return {
            detailList: [
                { explain: '签到成功', time: '2025.01.20', type: 1, integralNum: 10, balance: 30 },
                { explain: '累计观看视频', time: '2025.01.20', type: 1, integralNum: 10, balance: 30 },
                { explain: '购买课程', time: '2025.01.20', type: 2, integralNum: 10, balance: 30 },
                { explain: '累计观看视频', time: '2025.01.20', type: 1, integralNum: 10, balance: 30 },
                { explain: '购买课程', time: '2025.01.20', type: 1, integralNum: 10, balance: 30 },
            ]
        };
    },

    mounted() {

    },

    methods: {

    },
};
</script>

<style lang="scss" scoped>
.bg_gray {
    background: #F3F3F3;
    width: 100%;
    min-height: calc(100vh - #{$pageTopHeight});
}

.integral_detail {
    width: $pageMainWidth;
    height: 767px;
    background: #FFFFFF;
    border-radius: 10px;
    margin: 30px auto;
    padding: 20px;
    box-sizing: border-box;

    .detail_text {
        font-weight: bold;
        font-size: 18px;
        color: #111111;
        padding-bottom: 15px;
        border-bottom: 1px solid rgba(36, 35, 36, 0.1);
    }

    .detail_box {
        padding-top: 20px;

        .detail_top {
            height: 50px;
            background: #FAFBFC;
            font-weight: bold;
            font-size: 18px;
            color: #333333;
            line-height: 50px;
            padding: 0 20px;
            box-sizing: border-box;
        }

        .detail_content {
            .detail_one {
                line-height: 50px;
                height: 50px;
                color: #666666;
                padding: 0 20px;
                box-sizing: border-box;

                .red_color {
                    color: rgba(250, 73, 73, 1);
                }

                .green_color {
                    color: #13D6AA;
                }
            }

            .detail_one_active {
                background: #FAFBFC;
            }
        }

        .top_one {
            width: 25%;
            text-align: start;
        }
    }
}
</style>